import { Model } from '@models/model';

export class PagesTemplate extends Model {
  idPageTemplate: number;
  name: string;
  type: string;
  editorHtml: string;
  previewHtml: string;
  thumbnail: string;
}
